import { useHits } from 'react-instantsearch'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import zip from 'lodash/zip'

import { isDefined } from '../utils/types/misc'

interface SearchQuery {
  q: string
  count: number
}

interface DropdownMenuData {
  value: string
  label: string
  highlight?: TrustedHTML
}

interface UseSearchQueriesResult {
  suggestions: DropdownMenuData[]
  isLoading: boolean
}

const useSearchQueries = (): UseSearchQueriesResult => {
  const { results } = useHits<SearchQuery>()

  // Try to always show equal amount per group if available
  const grouped = groupBy(results?.hits, 'group')
  const values = Object.values(grouped)
  const interleaved = zip(...values).flat()
  const picked = sortBy(interleaved.slice(0, 6).filter(isDefined), ['word_count', '-score'])

  const suggestions = picked.map((hit) => {
    // eslint-disable-next-line no-underscore-dangle
    const highlight = hit._highlightResult.q.matchLevel !== 'none'
      // eslint-disable-next-line no-underscore-dangle
      ? hit._highlightResult.q.value
      : undefined
    return {
      label: hit.q,
      value: hit.q,
      highlight,
    }
  }) || []

  const isLoading = !results

  return {
    suggestions,
    isLoading,
  }
}

export default useSearchQueries
